export enum loadState {
    loading,
    found,
    notFound,
    error
}